<template>
  <el-upload
    class="image-uploader"
    action="/api/upload/image"
    :show-file-list="false"
    :drag="true"
    accept=".png,.jpeg,.jpg,.gif"
    :with-credentials="true"
    :on-success="uploadSuccess"
  >
    <p v-if="previewUrl == null || previewUrl === ''">拖拽图片到此或点击选择</p>
    <img v-else :src="previewUrl"/>
  </el-upload>
</template>

<script>
export default {
  name: 'ImageUploader',
  props: {
    // 上传成功处理函数
    uploadSuccess: {
      required: true
    },
    // 预览图地址
    previewUrl: {
      type: String
    }
  }
}
</script>

<style scoped lang="scss">
.image-uploader {
  /deep/ .el-upload {
    width: 100%;
    .el-upload-dragger {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }
  }
}
</style>
